import { render, staticRenderFns } from "./TermsComponent.vue?vue&type=template&id=f16db8f8&"
import script from "./TermsComponent.vue?vue&type=script&lang=js&"
export * from "./TermsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports